import { useEffect, useState } from "react";

const links = [
  { label: "Pre-Save", id: "presave" },
  { label: "Music", id: "music" },
  { label: "Merch", id: "merch" },
  { label: "Gallery", id: "gallery" },
  { label: "Tour", id: "tour" },
  { label: "Newsletter", id: "newsletter" },
  { label: "Contact", id: "contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#E6EAEF]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-5 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`font-mono-meta text-[11px] tracking-[0.32em] uppercase transition-colors duration-500 ${
            scrolled ? "text-[#0A0A0A]" : "text-white"
          } hover:text-[#6B8FAE]`}
          style={!scrolled ? { textShadow: "0 1px 8px rgba(0,0,0,0.4)" } : {}}
        >
          Sylas Ever
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`font-mono-meta text-[11px] tracking-[0.28em] uppercase link-underline transition-colors duration-500 ${
                scrolled
                  ? "text-[#1A1A1A]/80 hover:text-[#0A0A0A]"
                  : "text-white/90 hover:text-white"
              }`}
              style={!scrolled ? { textShadow: "0 1px 6px rgba(0,0,0,0.35)" } : {}}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          className={`md:hidden font-mono-meta text-[11px] tracking-[0.3em] uppercase ${
            scrolled ? "text-[#0A0A0A]" : "text-white"
          }`}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#E6EAEF] bg-white/98 backdrop-blur-md px-6 py-10 flex flex-col gap-6"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-serif-display text-3xl text-left text-[#0A0A0A] hover:text-[#6B8FAE] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
